<template>

    <div class="h-100 w-100">
        <link href='https://api.mapbox.com/mapbox-gl-js/v1.11.0/mapbox-gl.css' rel='stylesheet' />

    <div id="map" class="my-auto" :style="{width : width, height : height}"></div>
    
    </div>
          
       
            
    

    
</template>

<script>


export default {
    name : 'Map',
    props: ['width', 'height', "stylemap"],
    mounted() {
        var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');
        const geojson_files = this.$storage.ref('geojson');
        mapboxgl.accessToken = 'pk.eyJ1IjoiYW50b2luZTI3OTQwIiwiYSI6ImNrYzU0ZDRwejBlMm8ydXJpMWc5Yzl4eG4ifQ.qxFud6gO7OhHs4ampjyOTg';
        var map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/' + this.$props.stylemap,
        center : [1.334275,49.160468],
        zoom : 12,
        });
        this.$emit('map', map);

    }
}
</script>
